import { AiApi } from '../../../api/aiApi';
import Icons from '../../../component/svgs/icons';
import React, { useEffect, useRef, useState } from 'react';
import { InfoPopUpModalData } from '../../../utils/pageContent';

const AssistantTab = ({ title }) => {
  const [msg, setMsg] = useState('');
  const messagesEndRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const tabData = InfoPopUpModalData.assistantTabData;
  const [msgs, setMsgs] = useState([
    {
      msg: tabData.messageBeforeName + userData?.name + tabData.messageAfterName,
      sender: false
    }
  ]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!msg.trim()) return;
    setLoading(true);
    setMsgs((prev) => [...prev, { sender: true, msg }]);
    setMsg('');

    const payload = {
      token: token,
      user_id: userData?.id,
      feature_name: title,
      question: msg
    };

    try {
      const res = await AiApi.appTutorialChat(payload);
      if (res?.data?.meta?.code === 200) {
        setMsgs((prev) => [...prev, { sender: false, msg: res?.data?.data?.answer }]);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error sending message:', error);
    } finally {
      setMsg('');
      scrollToBottom();
      setLoading(false);
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [msgs]);

  return (
    <>
      <div className="md:mb-[46px] mb-6">
        <h5 className="md:text-[22px] text-[18px] font-medium">{tabData.askTheAssistantText}</h5>
        <p className="md:text-[18px] text-[14px]">{tabData.getInstantGuidanceTtext}</p>
      </div>
      <div className="h-[485px] border-2 border-black dark:border-shoorah-darkBg border-opacity-20 rounded-[10px]">
        <ul className="flex flex-col gap-[10px] md:h-[calc(100%-89px)] h-[calc(100%-79px)] md:pt-8 md:pr-11 md:ps-[50px] p-4 pb-0 overflow-x-hidden no-scrollbar overflow-y-auto">
          {msgs.length > 0 &&
            msgs?.map((item, index) => (
              <li
                key={index}
                className={`lg:max-w-[850px] xl:max-w-[900px] md:max-w-[550px] max-w-[250px] 
                  ${
                    !item.sender
                      ? 'bg-shoorah-active text-white'
                      : 'bg-[#FAFBFE] dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg text-shoorah-sidebarBackground opacity-60'
                  } 
                  py-4 md:px-6 px-4 text-[12px] md:text-[16px] md:rounded-[26px] rounded-[16px] w-fit 
                  ${
                    !item.sender
                      ? 'md:rounded-tl-[10px] rounded-tl-[8px]'
                      : 'md:rounded-tr-[10px] rounded-tr-[8px] ml-auto md:mb-[30px] mb-5 border-[#B6C0F3] border-[1.64px]'
                  }
                `}
              >
                {item.msg}
              </li>
            ))}
          {loading && (
            <li className={`md:mb-[30px] mb-5`}>
              <div className="flex space-x-2 animate-pulse">
                <div className="w-3 h-3 bg-shoorah-primary rounded-full"></div>
                <div className="w-3 h-3 bg-shoorah-secondary rounded-full"></div>
                <div className="w-3 h-3 bg-shoorah-primary rounded-full"></div>
              </div>
            </li>
          )}
          <li ref={messagesEndRef}></li>
        </ul>
        <form
          onSubmit={handleSubmit}
          className="bg-black bg-opacity-5 md:h-[89px] h-[79px] p-4 md:pr-11 md:ps-[50px] flex md:gap-[23px] gap-4 justify-between"
        >
          <input
            placeholder="Type a message..."
            onChange={(e) => setMsg(e.target.value)}
            value={msg}
            className="rounded-[10px] bg-white dark:bg-shoorah-darkBgTabColor md:text-[16px] text-[14px] dark:text-shoorah-darkBg md:w-[calc(100%-80px)] w-[calc(100%-73px)] md:p-4 p-3 text-[#18202F] border border-[#000] border-opacity-20 focus:outline-none"
          />
          <button
            type="submit"
            className="md:w-[57px] w-[47px] md:h-[57px] h-[47px] rounded-full border-[1.3px] border-[#000] dark:border-shoorah-darkBgTabColor border-opacity-20 flex items-center justify-center bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg"
          >
            <Icons.sendIcon className="dark:!text-shoorah-darkBg w-5 h-5 lg:w-6 lg:h-6" />
          </button>
        </form>
      </div>
    </>
  );
};

export default AssistantTab;
